import HeadTittle from "../../../components/HeadTittle";
import routes from "../../../Routes/routes";
import StepperTabs from "../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../components/StepperTabs/StepTab";
import {STEPS_UPDATE_DEVICE} from "./Model/Model";
import SectionCreateDeviceData from "./SubComponents/SectionCreateDeviceData";
import {ButtonNextStep, ButtonPrevStep} from "../../../components/buttons/ButtonNavigation";
import SectionCreateDeviceOptions from "./SubComponents/SectionCreateDeviceOptions";
import SectionCreateDeviceSecurity from "./SubComponents/SectionCreateDeviceSecurity";
import SectionCreateDeviceAuthentication from "./SubComponents/SectionCreateDeviceAuthentication";
import SectionCreateDeviceRelay from "./SubComponents/SectionCreateDeviceRelay";
import SectionCreateDevice1FA from "./SubComponents/SectionCreateDevice1FA";
import SectionCreateDevice2FA from "./SubComponents/SectionCreateDevice2FA";
import DeleteModal from "../../Modals/DeleteModal";
import React from "react";
import {CommonDevicesApp} from "./Funtionality/CommonDevicesApp";
import {UpdateDevicesApp} from "./Funtionality/UpdateDevicesApp";
import ButtonAction from "../../../components/buttons/ButtonAction";
import {EditIcon} from "../../../components/buttons/IconButtons";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 04 de 05 de 2026
 */

const UpdateDevices = () => {

    const {
        data,
        t,
        handleChange,
        emptyFields,
        id,
        deleteDeviceShow,
        setDeleteDeviceShow,
        selectDeviceForDelete,
        setDeletedFlag,
        location,zoneIdProps,
        deviceTypeDistance,
        defaultDistance,
        handleError,
        deviceCustomAccess,
        deviceDepartment,
        deviceCustomAccessTwoFa,
        deviceDepartmentTwoFa,
        zoneNameProps,
        dispatch,
        navigate,
        setEmptyFields,
        setData,
        modified,

        steps,
        setSteps,
        activeStep,
        setActiveStep,
        setModified,

        handleStepChange,
        handleClearSteps,
        deleteSelectedDevices,
        handleValidateSteps,

        setDeviceCustomAccess,
        setDeviceDepartment,
        setDeviceCustomAccessTwoFa,
        setDeviceDepartmentTwoFa,

        selectForDeleteEmp1FA,
        setSelectForDeleteEmp1FA,
        selectForDeleteDepa1FA,
        setSelectForDeleteDepa1FA,

        selectForDeleteEmp2FA,
        setSelectForDeleteEmp2FA,
        selectForDeleteDepa2FA,
        setSelectForDeleteDepa2FA
    } = CommonDevicesApp();


    const {handleUpdate} = UpdateDevicesApp({
        setSteps,
        handleError,
        deviceCustomAccess,
        setDeviceCustomAccess,
        deviceDepartment,
        setDeviceDepartment,
        deviceCustomAccessTwoFa,
        setDeviceCustomAccessTwoFa,
        deviceDepartmentTwoFa,
        setDeviceDepartmentTwoFa,
        zoneNameProps,
        zoneIdProps,
        setModified,
        defaultDistance,
        data,
        t,
        id,
        dispatch,
        navigate,
        setEmptyFields,
        setData,
        modified
    })

    // The details route reuses this page in read-only mode
    const disabled = location?.pathname?.includes(routes.devices.details);

    return (
        <>
            <HeadTittle name={id === undefined ? 'create' : disabled ? 'details' : 'update'}
                        link={location?.state?.zoneNameProps !== undefined ? routes.zone.details + zoneIdProps : routes.devices.list}>
                {!disabled &&
                <div className='col-12 d-flex justify-content-end gap-2 flex-wrap mb-4'>
                    <ButtonAction
                        id={'btn_update_device'}
                        name='update'
                        className='btn-icon-edit'
                        Icon={EditIcon}
                        onClick={() => { handleUpdate() }}
                    />
                </div>
                }
            </HeadTittle>


            <StepperTabs
                id={id}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => { }}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={STEPS_UPDATE_DEVICE.DATA.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_UPDATE_DEVICE.DATA.INDEX && (
                        <>
                            <SectionCreateDeviceData data={data?.data} handleChange={handleChange}
                                                     handleClear={handleClearSteps}
                                                     emptyFields={emptyFields} t={t} id={id} location={location}
                                                     disabled={disabled}/>
                            { id === null &&
                            <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                                <ButtonNextStep
                                    id='btn_ce_next_details'
                                    text='next'
                                    click={() => {
                                        if (handleValidateSteps()) {
                                            setActiveStep((prevStep) => prevStep + 1)
                                        }
                                    }}
                                />
                            </div>
                            }
                        </>
                    )}
                </StepTab>
                <StepTab index={STEPS_UPDATE_DEVICE.OPTIONS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_UPDATE_DEVICE.OPTIONS.INDEX && (
                        <>
                            <SectionCreateDeviceOptions data={data} handleChange={handleChange} t={t}
                                                        handleClear={handleClearSteps} id={id}
                                                        emptyFields={emptyFields} disabled={disabled}/>
                            { id === null &&
                            <div className='col-12 d-flex justify-content-between mt-3'>
                                <ButtonPrevStep
                                    id='btn_ce_back_options'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_ce_next_options'
                                    text='next'
                                    click={() => {
                                        if (handleValidateSteps()) {
                                            setActiveStep((prevStep) => prevStep + 1)
                                        }
                                    }}
                                />
                            </div>
                            }
                        </>
                    )}
                </StepTab>
                <StepTab index={STEPS_UPDATE_DEVICE.SECURITY.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_UPDATE_DEVICE.SECURITY.INDEX && (
                        <>
                            <SectionCreateDeviceSecurity data={data} handleChange={handleChange} t={t}
                                                         handleClear={handleClearSteps} id={id}
                                                         emptyFields={emptyFields} disabled={disabled}/>
                            { id === null &&
                            <div className='col-12 d-flex justify-content-between mt-3'>
                                <ButtonPrevStep
                                    id='btn_ce_back_security'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_ce_next_security'
                                    text='next'
                                    click={() => {
                                        if (handleValidateSteps()) {
                                            setActiveStep((prevStep) => prevStep + 1)
                                        }
                                    }}
                                />
                            </div>
                            }
                        </>
                    )}
                </StepTab>
                <StepTab index={STEPS_UPDATE_DEVICE.AUTHENTICATION.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_UPDATE_DEVICE.AUTHENTICATION.INDEX && (
                        <>
                            <SectionCreateDeviceAuthentication data={data} handleChange={handleChange} t={t}
                                                               handleClear={handleClearSteps} id={id}
                                                               deviceTypeDistance={deviceTypeDistance}
                                                               defaultDistance={defaultDistance}
                                                               emptyFields={emptyFields} disabled={disabled}/>

                            { id === null &&
                            <div className='col-12 d-flex justify-content-between mt-3'>
                                <ButtonPrevStep
                                    id='btn_ce_back_authentication'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_ce_next_authentication'
                                    text='next'
                                    click={() => {
                                        if (handleValidateSteps()) {
                                            setActiveStep((prevStep) => prevStep + 1)
                                        }
                                    }}
                                />
                            </div>
                            }
                        </>
                    )}
                </StepTab>
                <StepTab index={STEPS_UPDATE_DEVICE.RELAY.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_UPDATE_DEVICE.RELAY.INDEX && (
                        <>
                            <SectionCreateDeviceRelay data={data} id={id} handleChange={handleChange}
                                                      t={t} handleClear={handleClearSteps}
                                                      emptyFields={emptyFields} disabled={disabled}/>
                            { id === null &&
                            <div className='col-12 d-flex justify-content-between mt-3'>
                                <ButtonPrevStep
                                    id='btn_ce_back_relay'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_ce_next_relay'
                                    text='next'
                                    click={() => {
                                        if (handleValidateSteps()) {
                                            setActiveStep((prevStep) => prevStep + 1)
                                        }
                                    }}
                                />
                            </div>
                            }
                        </>
                    )}
                </StepTab>
                <StepTab index={STEPS_UPDATE_DEVICE.UNOFA.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_UPDATE_DEVICE.UNOFA.INDEX && (
                        <>
                            <SectionCreateDevice1FA data={data} handleChange={handleChange} t={t} handleClear={handleClearSteps}
                                                    setDeviceCustomAccess={setDeviceCustomAccess} id={id}
                                                    setDeviceDepartment={setDeviceDepartment}

                                                    selectForDeleteEmp={selectForDeleteEmp1FA}
                                                    setSelectForDeleteEmp={setSelectForDeleteEmp1FA}
                                                    selectForDeleteDepa={selectForDeleteDepa1FA}
                                                    setSelectForDeleteDepa={setSelectForDeleteDepa1FA}
                                                    disabled={disabled}
                            />
                            { id === null &&
                            <div className='col-12 d-flex justify-content-between mt-3'>
                                <ButtonPrevStep
                                    id='btn_ce_back_uno_fa'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_ce_next_uno_fa'
                                    text='next'
                                    click={() => {
                                        if (handleValidateSteps()) {
                                            setActiveStep((prevStep) => prevStep + 1)
                                        }
                                    }}
                                />
                            </div>
                            }
                        </>
                    )}
                </StepTab>
                <StepTab index={STEPS_UPDATE_DEVICE.DOSFA.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_UPDATE_DEVICE.DOSFA.INDEX && (
                        <>
                            <SectionCreateDevice2FA data={data} handleChange={handleChange} t={t}
                                                    handleClear={handleClearSteps} id={id}
                                                    setDeviceCustomAccess={setDeviceCustomAccessTwoFa}
                                                    setDeviceDepartment={setDeviceDepartmentTwoFa}

                                                    selectForDeleteEmp={selectForDeleteEmp2FA}
                                                    setSelectForDeleteEmp={setSelectForDeleteEmp2FA}
                                                    selectForDeleteDepa={selectForDeleteDepa2FA}
                                                    setSelectForDeleteDepa={setSelectForDeleteDepa2FA}
                                                    disabled={disabled}
                            />
                            { id === null &&
                            <div className='col-12 d-flex justify-content-between mt-3'>
                                <ButtonPrevStep
                                    id='btn_ce_back_dos_fa'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_ce_next_dos_fa'
                                    text='next'
                                    click={() => {
                                        if (handleValidateSteps()) {
                                            setActiveStep((prevStep) => prevStep + 1)
                                        }
                                    }}
                                />
                            </div>
                            }
                        </>
                    )}
                </StepTab>
            </StepperTabs>

            <DeleteModal
                show={deleteDeviceShow}
                onHide={() => setDeleteDeviceShow(false)}
                onClickFn={() => deleteSelectedDevices(selectDeviceForDelete)}
                data={selectDeviceForDelete}
                title_modal={t('delete_device')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('device')}
                onDelete={() => setDeletedFlag(true)}
            />
        </>
    );
}

export default UpdateDevices
